import { render, staticRenderFns } from "./EntityContentView.vue?vue&type=template&id=cfa18b26&scoped=true"
import script from "./EntityContentView.vue?vue&type=script&lang=js"
export * from "./EntityContentView.vue?vue&type=script&lang=js"
import style0 from "./EntityContentView.vue?vue&type=style&index=0&id=cfa18b26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa18b26",
  null
  
)

export default component.exports